import { jsxs as t, jsx as i } from "react/jsx-runtime";
import { c as l } from "./index-BNmRGtA6.js";
import { c as d } from "./clsx-OuTLNxxd.js";
import './Spinner.css';const e = "_small_1fp3w_1", m = "_medium_1fp3w_5", o = "_large_1fp3w_9", _ = "_spinner_1fp3w_13", p = "_light_1fp3w_86", v = "_dark_1fp3w_89", a = {
  small: e,
  medium: m,
  large: o,
  spinner: _,
  light: p,
  dark: v
}, c = l(a.spinner, {
  variants: {
    size: {
      s: a.small,
      m: a.medium,
      l: a.large
    },
    variant: {
      light: a.light,
      dark: a.dark
    }
  },
  defaultVariants: {
    size: "m",
    variant: "light"
  }
}), u = ({ className: s, size: r, variant: n }) => /* @__PURE__ */ t(
  "div",
  {
    "aria-label": "loading",
    className: d(c({ size: r, variant: n }), s),
    "data-cxy-name": "spinner",
    role: "status",
    children: [
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {}),
      /* @__PURE__ */ i("div", {})
    ]
  }
);
export {
  u as S
};
